import { render, staticRenderFns } from "./IntraoralListPanel.vue?vue&type=template&id=6eab1903&scoped=true&"
import script from "./IntraoralListPanel.vue?vue&type=script&lang=js&"
export * from "./IntraoralListPanel.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralListPanel.vue?vue&type=style&index=0&id=6eab1903&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eab1903",
  null
  
)

export default component.exports